import React from 'react'
import styles from './PublishModal.scss'

const PublishModal = props =>
  <div className={styles.PublishModal}>PublishModal
  </div>

PublishModal.propTypes = {}

export default PublishModal



// WEBPACK FOOTER //
// ./src/components/PublishModal/PublishModal.js